<template>
	<page>
		<module>
			<view-list work-type="2" ref="view" selector :view-config="auth('b_plan_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="生产计划编号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="计划状态">
							<c-select name="plan_states" :options="salesOrderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="排产状态">
							<c-select name="scheduling_states" :options="schedulingStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_plan_create')" v-lock="lock('b_plan_create')" prepend-icon="tf-add" @click="editOrder()">创建生产计划</c-button>
					<c-button v-if="auth('b_plan_export')" v-lock="lock('b_plan_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_plan_export')" v-lock="lock('b_plan_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>

                    <c-button v-if="auth('b_plan_create') || auth('b_plan_edit')" v-lock="lock('b_plan_create')" prepend-icon="tf-import" @click="importData()">导入</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_plan_transfer')" v-lock="lock('b_plan_transfer')" prepend-icon="tf-order" @click="transferWork(data)">转生产工单</c-button>
					<c-button v-if="auth('b_plan_export')" v-lock="lock('b_plan_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_plan_export')" v-lock="lock('b_plan_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_plan_print')" v-lock="lock('b_plan_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_plan_log')" v-lock="lock('b_plan_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #order_code="{data}">
					<c-link @click="globalDialog('planDetail', {props: {id: data.id}})">{{data.order_code}}</c-link>
				</template>

				<!--计划状态-->
				<template #plan_state="{data}">
					<c-state dict="salesOrderStateDic" tag :value="data.plan_state"></c-state>
				</template>
				
				<!--排产进度%-->
				<template #scheduling_progress="{data}">
					<c-progress :rate="[data.scheduling_count, data.plan_count]" :color="((data.scheduling_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
				</template>

				<!--生产进度%-->
				<template #plan_progress="{data}">
					<c-progress :rate="[data.scheduling_ok_count, data.plan_count]" :color="((data.scheduling_ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--逾期状态-->
				<template #plan_date_state="{data}">
					<c-state type="expectedDate" :value="data.expected_date"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_plan_edit')" v-lock="lock('b_plan_edit')" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('planDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_plan_print')" v-lock="lock('b_plan_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_plan_edit')" v-lock="lock('b_plan_edit')" icon="tf-copy" @click="copyOrder(data)">复制</c-table-button>
						<c-table-button v-if="auth('b_plan_transfer')" v-lock="lock('b_plan_transfer')" :disabled="!(data.plan_state == 2)" icon="tf-order" @click="transferWork([{id:data.id}])">转生产工单</c-table-button>
						<c-table-button v-if="auth('b_plan_transfer_assemble')" v-lock="lock('b_plan_transfer_assemble')" :disabled="!(data.plan_state == 2)" icon="tf-order-trans" @click="transferAssemble(data)">转装配工单</c-table-button>
						<c-table-button v-if="auth('b_plan_edit')" v-lock="lock('b_plan_edit')" :disabled="!(data.plan_state != 2)" icon="tf-start" @click="editState(data, 2)">开始</c-table-button>
						<c-table-button v-if="auth('b_plan_edit')" v-lock="lock('b_plan_edit')" :disabled="!(data.plan_state == 2)" icon="tf-finish" @click="editState(data, 3)">完成</c-table-button>
						<c-table-button v-if="auth('b_plan_edit')" v-lock="lock('b_plan_edit')" :disabled="!(data.plan_state == 2)" icon="tf-pause" @click="editState(data, 5)">暂停</c-table-button>
						<c-table-button v-if="auth('b_plan_edit')" v-lock="lock('b_plan_edit')" :disabled="!(data.plan_state != 4)" icon="tf-cancel" @click="editState(data, 4)">取消</c-table-button>
						<c-table-button v-if="auth('b_plan_delete')" v-lock="lock('b_plan_delete')" icon="tf-trash" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				view_id: 10014
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['salesOrderStateDic','schedulingStateDic'])
		},
		
		methods: {
			
			/******新建/编辑计划*******/
			editOrder(data) {
				//修改
				if(data){
					this.globalDialog('planEdit', {data}, this.$refs.view.refresh);
				}else{
					this.globalDialog('planEdit', {data}, this.$refs.view.update);
				}
			},
			
			/******复制计划********/
			copyOrder(data) {
				data.is_copy = true;
				this.globalDialog('planEdit', {data}, this.$refs.view.refresh);
			},
			
			/******修改计划状态************/
			editState(data, plan_state){
				this.request({
					url: '/plan/editState',
					data: {
						id: data.id, 
						plan_state: plan_state,
					},
					loading: true,
					success: data => {
						var mess = '';
						if(plan_state == 2){
							mess = '修改为「执行中」状态成功';
						}else if(plan_state == 3){
							mess = '修改为「已完成」状态成功';
						}else if(plan_state == 4){
							mess = '修改为「取消」状态成功';
						}
						
						this.$message({
							message: mess,  // 提示内容,
							type: 'success'
						});
						//刷新
						this.$refs.view.refresh();
					}
				});
			},

			/******删除计划************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除生产计划【'+data.order_code+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/plan/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******转生产工单******/
			transferWork(selectData) {
				
				//方式一（只包含订单产品）
				this.request({
					url: '/plan/product',
					data: {
						plan_ids: selectData.map(data => data.id)
					},
					success: data => {
						this.planProduct = data.map(item => {
							item.order_product_id = item.id;
							item.unit_count = item.unit_count || 1;
							item.order_id = item.plan_id;
							item.main_product_count = item.plan_count;
							item.ref_type = 2;
							return item;
						});
						
						this.globalDialog('batchWorkEdit', {
							data: {
								ref_type: 2,
								orderProductList: this.planProduct
							}
						},
						()=>{
							this.$refs.view.refresh();
						});
					}
				})
			},
			
			//转装配工单
			transferAssemble(selectData) {
				this.request({
					url: '/plan/productBom',
					data: {
						product_source: [1],		//只查询自产产品
						plan_ids: [selectData.id]
					},
					success: data => {
						if(data != null && data.length > 0 && data[0].childProduct != null && data[0].childProduct.length > 0){
							this.orderProduct = data[0].childProduct.map(item => {
								item.order_product_id = item.id;
								item.unit_count = item.unit_count || 1;
								item.ref_type = 2;
								item.main_product_count = item.plan_count;
								return item;
							});
							this.globalDialog('assembleEdit', {
								props: {
									ref_type: 2,
									ref_id: selectData.id,
									orderProductList: this.orderProduct
								}
							},
							()=>{
								this.$refs.view.refresh();
							});
						}else{
							this.$message({
								message:'没有可以转单的产品',  // 提示内容,
								type: 'error'
							});
						}
					}
				})
			},
			
			/*******导入数据************/
			importData() {
			    this.$refs.view.excelImport(Object.assign({}, {
			        view_id: this.view_id
			    }));
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>